
/* START_TEMPLATE */
define('hbs!app/templates/signature_pad',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return " <small>("
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.Optional : stack1), depth0))
    + ")</small>";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, lambda=this.lambda, buffer = "<label>\n  "
    + escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"title","hash":{}}) : helper)));
  stack1 = helpers.unless.call(depth0, (depth0 != null ? depth0.required : depth0), {"name":"unless","hash":{},"fn":this.program(1, data),"inverse":this.noop});
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</label>\n<canvas></canvas>\n<div>\n    <button type=\"button\" name=\"clear\">"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.Clear : stack1), depth0))
    + "</button>\n    <button type=\"button\" name=\"undo\">"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.Undo : stack1), depth0))
    + "</button>\n</div>\n";
}});
Handlebars.registerPartial('app/templates/signature_pad', t);
return t;
});
/* END_TEMPLATE */
;
